// Import and re-export from shared types
import type { WelcomeMessageType } from './types/welcomeMessage';

export { SignUpModalScreenName } from './shared-types';
export { WelcomeMessageType } from './types/welcomeMessage';

export enum CreateAccountType {
  Free = 'free',
  Essentials = 'essentials',
  Creator = 'creator',
  Pro = 'pro',
  Business = 'business',
}

export enum CardPlanDetailsTitleIconId {
  Download = 'download',
}
export interface WelcomeMessageProps {
  welcomeMessageType?: WelcomeMessageType | string;
}
